// #flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";
import { config } from "dotenv";

const description = "A widget to preview and link to a given podcast episode.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Podcast pointer",
  id: "podcast-pointer",
  groupsWithAccess: ["admin_user"],
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/podcast-pointer-hub/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import("app/components/tools/PodcastPointerConfigTool/PodcastPointerConfigTool"),
    loading: DynamicImportLoader,
    modules: ["PodcastPointerConfigTool"]
  })
};

export default CONFIG;
